/**
 * Editorial identity for Modern Nomad Living.
 *
 * The site uses an Organization-as-author model (Wirecutter / Economist style).
 * No individual authors, no Person schema, no fake LinkedIn URLs. E-E-A-T is
 * established through the Editorial Standards section on /about.
 */
import founderPortrait from '@/assets/founder-portrait.jpg.asset.json';

export const EDITORIAL_TEAM = {
  name: 'Modern Nomad Living Editorial Team',
  shortName: 'The Editorial Team',
  initials: 'MN',
  bio: 'Researched and edited by the Modern Nomad Living team — writers, builders, and full-time nomads who have lived these systems first-hand. Every guide is verified against field experience or primary sources before publication.',
  expertise: ['Van life', 'Off-grid systems', 'Boat living', 'Camping logistics'],
  url: 'https://modernnomadliving.com/about#editorial-standards',
} as const;

/**
 * Founder & Editor-in-Chief.
 *
 * Used as the Person node under Organization.founder in JSON-LD and shown
 * on /about as the human anchor behind the Editorial Team. The site still
 * publishes articles under the collective Editorial Team byline — the
 * founder is not attributed as author on individual articles.
 */
export const FOUNDER = {
  name: 'Karl Flemming',
  role: 'Founder & Editor-in-Chief',
  image: founderPortrait.url,
  bio: 'Karl founded Modern Nomad Living in 2024 after more than a decade of moving between a converted Sprinter, an off-grid cabin in northern Sweden, and long stretches aboard a 32-foot sailboat in the Baltic. A former product designer, he started the site to publish the kind of specific, tested, number-driven guides he wished had existed when he first left conventional housing.',
  shortBio: 'Founder of Modern Nomad Living. Full-time nomad for over a decade across vans, off-grid cabins, and liveaboard boats.',
  location: 'Sweden',
  url: 'https://modernnomadliving.com/about#founder',
} as const;